/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import { camelToTitleCase } from "../../utility/index";
import AttributeDisplayList from "../AttributeDisplays/AttributeDisplayList";

/**
 * This component displays the contacts details to the user.
 * @param {object} currentContact The contact to display the info for.
 */
const ContactDetails = ({ phone, queue, contactType }) => {
	const attributes = [
		{ name: "Connection Type", value: camelToTitleCase(contactType), id: "connection-type" },
		{ name: "Queue", value: queue, id: "queue" },
	];

	if (contactType === "voice") {
		attributes.push({
			name: "Caller",
			value: phone,
			id: "caller",
		});
	}
	return phone || queue ? (
		<div>
			<AttributeDisplayList attributes={attributes} />
		</div>
	) : null;
};

ContactDetails.propTypes = {
	phone: PropTypes.string,
	queue: PropTypes.string,
	contactType: PropTypes.string,
};

export default ContactDetails;
